<template>
  <div>
    <div class="allProject" v-for="(item,index) in tableList" :key="index">
      <div @click="enterDetail(item)">
        <div class="facialName">
          <div class="facialNext">
            <div class="facialList">
              <img class="facialImg" src="../../assets/icon/me.png" alt="">
              <span>{{item.projectName}}</span>
              <span>{{ item.mobile.replace(item.mobile.substr(3, 4), '****') }}</span>
              <img class="myself" src="../../assets/icon/myself.png" alt="">
            </div>
            <div class="nurseName">预检台</div>
          </div>
        </div>
        <div class="outpatient">
          <img class="facialImg" src="../../assets/icon/me.png" alt="">
          <span>预检台接待时间:</span>
          <span class="outName">{{item.doctorName}}</span>
        </div>
        <div class="outpatient">
          <img class="facialImg" src="../../assets/icon/me.png" alt="">
          <span>{{item.projectName}}</span>
          <span>{{ item.mobile.replace(item.mobile.substr(3, 4), '****') }}</span>
          <img class="myself" src="../../assets/icon/association.png" alt="">
        </div>
        <div class="outpatient">
          <img class="facialImg" src="../../assets/icon/me.png" alt="">
          <span>预检台接待时间:</span>
          <span class="outName">{{item.doctorName}}</span>
        </div>
      </div>
      <div class="split_line"></div>
      <div class="concat">
        <div class="contactWait" @click="escort">关联陪同</div>
        <div class="contactWait">解绑</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableList: [
        {
          projectName: "张三",
          mobile: '14525878956',
          doctorName: '苏医生'
        },

      ],
    }
  },
  methods: {
    enterDetail(item) { },
    // 关联陪同操作
    escort() {
      this.$router.push("/confirm")
    },
  }
}
</script>
<style scoped>
@import "../../assets/css/customer.css";
</style>


// WEBPACK FOOTER //
// src/components/customerReception/customFlat.vue